import { IoMdCloudOutline, IoMdCloudDone } from 'react-icons/io';
import { useTranslation } from 'react-i18next';

interface NetworkBannerProps {
  showBanner: boolean;
  bannerType: 'offline' | 'back-online' | null;
}

export default function NetworkBanner({ showBanner, bannerType }: NetworkBannerProps) {
  const { t } = useTranslation("common");
  if (!showBanner || !bannerType) return null;

  const isOffline = bannerType === 'offline';

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '6px',
      padding: '6px 16px',
      backgroundColor: '#f9fafb',
      borderBottom: '1px solid #e5e7eb',
      color: isOffline ? '#dc2626' : '#16a34a',
      fontSize: '12.5px',
      fontWeight: '500',
    }}>
      {isOffline ? <IoMdCloudOutline size={14} /> : <IoMdCloudDone size={14} />}
      <span>{isOffline ? t("network.offline") : t("network.backOnline")}</span>
    </div>
  );
}
